import styled from 'styled-components'
import { AnswerText, ModalButton } from '../styles'

const AssignButton = styled(ModalButton)`
  padding: 0 8px;
  font-size: 1rem;
`


const Label = styled(AnswerText)`
  max-width: fit-content;
  font-weight: 500;
  font-size: 0.7rem;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  padding: 0 5px;

  &:hover {
    background: rgba(0, 51, 255, 0.18);
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  }
`


export { AssignButton, Label }
